<script context="module" lang="ts">
    export type IconName = 'info' | 'success' | 'warning' | 'error' | 'chevron-left' | 'chevron-right' | 'moon' | 'globe';
</script>

<script lang="ts">
    export let name: IconName;
    export let size: number = 16;
</script>

<svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    stroke-width="1"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    class="icon icon--{name}"
>
    {#if name === 'info'}
        <circle cx="8" cy="8" r="6.5"/>
        <line x1="8" y1="7.5" x2="8" y2="11"/>
        <circle cx="8" cy="5.25" r="0.6" fill="currentColor" stroke="none"/>
    {:else if name === 'success'}
        <circle cx="8" cy="8" r="6.5"/>
        <polyline points="5.25,8.25 7,10.25 10.75,5.75"/>
    {:else if name === 'warning'}
        <path d="M8 2.5L14.25 13.25H1.75L8 2.5Z"/>
        <line x1="8" y1="7" x2="8" y2="10"/>
        <circle cx="8" cy="11.75" r="0.6" fill="currentColor" stroke="none"/>
    {:else if name === 'error'}
        <circle cx="8" cy="8" r="6.5"/>
        <line x1="5.5" y1="5.5" x2="10.5" y2="10.5"/>
        <line x1="10.5" y1="5.5" x2="5.5" y2="10.5"/>
    {:else if name === 'chevron-left'}
        <polyline points="10 13 5 8 10 3"/>
    {:else if name === 'chevron-right'}
        <polyline points="6 13 11 8 6 3"/>
    {:else if name === 'moon'}
        <path d="M14 10.5A6.5 6.5 0 1 1 5.5 2 4.5 4.5 0 0 0 14 10.5z"/>
    {:else if name === 'globe'}
        <circle cx="8" cy="8" r="6.5"/>
        <path d="M1.5 8h13M8 1.5a10 10 0 0 0 0 13 10 10 0 0 0 0-13"/>
    {/if}
</svg>

<style>
    .icon {
        flex-shrink: 0;
        display: block;
    }
</style>
